(function() {
  const VARIANTS = JSON.parse(document.getElementById('lp-variant-data').textContent);
  const grid      = document.getElementById('lp-size-grid');
  const searchEl  = document.getElementById('lp-size-search');
  const emptyEl   = document.getElementById('lp-size-empty');
  const priceEl   = document.getElementById('lp-price');
  const priceOldEl  = document.getElementById('lp-price-old');
  const saleBadge   = document.getElementById('lp-sale-badge');
  const salePctEl   = document.getElementById('lp-sale-pct');
  const variantIn = document.getElementById('lp-variant-id');
  const addBtn    = document.getElementById('lp-add-btn');
  const buyBtn    = document.getElementById('lp-buy-btn');
  const selLabel  = document.getElementById('lp-selected-label');
  const noSelHint = document.getElementById('lp-no-sel-hint');
  const stickyBar = document.getElementById('lp-sticky');
  const stickySize= document.getElementById('lp-sticky-size');
  const stickyBtn = document.getElementById('lp-sticky-btn');
  const stickyPrice = document.getElementById('lp-sticky-price-current');
  const stickyPriceOld = document.getElementById('lp-sticky-price-old');
  const stickyImg = document.getElementById('lp-sticky-img');
  const heroForm  = document.getElementById('lp-product-form');
  const qtyInput  = document.getElementById('lp-qty-input');
  const qtyVal    = document.getElementById('lp-qty-val');
  const qtyMinus  = document.getElementById('lp-qty-minus');
  const qtyPlus   = document.getElementById('lp-qty-plus');
  const stockOverlay = document.getElementById('lp-stock-overlay');
  const mainImgEl = document.getElementById('lp-main-img');
  const wheelEl   = document.getElementById('lp-wheel');
  const saleToggleSaleBtn = document.getElementById('lp-sale-toggle-sale');
  const saleToggleAllBtn  = document.getElementById('lp-sale-toggle-all');
  const saleToggleCount = document.getElementById('lp-sale-toggle-count');
  let selectedId  = null;
  let quantity    = 1;
  let SALE_ONLY   = false;

  // V posuvníku ukazujeme IBA varianty skladom (v.available === true).
  // Vylúčime aj Shopify default "Default Title" — fantómový variant bez rozmeru.
  const IN_STOCK = VARIANTS.filter(function(v){ if(!(v.available && v.title && v.title.toLowerCase() !== 'default title')) return false; var _m = String(v.title).replace(/s*[xX×]s*/g,'x').match(/(d+)x(d+)/); if(_m && (parseInt(_m[1],10)%10!==0 || parseInt(_m[2],10)%10!==0)) return false; /* hide 5cm/odd dead-stock sizes */ return true; });
  (function(){function _d(t){var m=String(t).replace(/\s*[xX\u00d7]\s*/g,'x').match(/(\d+)x(\d+)/);return m?[+m[1],+m[2]]:[1e9,1e9];}function _k(v){var d=_d(v.title),lo=Math.min(d[0],d[1]),hi=Math.max(d[0],d[1]);return [(d[0]%10===0&&d[1]%10===0)?0:1,lo,hi];}IN_STOCK.sort(function(a,b){var ka=_k(a),kb=_k(b);return ka[0]-kb[0]||ka[1]-kb[1]||ka[2]-kb[2];});})();

  // Rozmer formátujeme s obyčajným "x" (15x15), nie špeciálnym znakom.
  function normalize(t) { return t.replace(/\s*[xX×]\s*/g, 'x').trim(); }

  // Je variant v zľave? Riadi sa Shopify compare_at_price.
  function isSaleVariant(v) {
    return !!(v && v.compareN > v.priceN);
  }

  function currentVariants() {
    return SALE_ONLY ? IN_STOCK.filter(isSaleVariant) : IN_STOCK;
  }

  // Aktualizuj počet v sale-toggle tlačidle
  const saleCount = IN_STOCK.filter(isSaleVariant).length;
  if (saleToggleCount) saleToggleCount.textContent = '(' + saleCount + ')';

  function renderPills(filter) {
    const q = (filter || '').toLowerCase().replace(/\s/g,'');
    const src = currentVariants();
    const filtered = q ? src.filter(v => normalize(v.title).toLowerCase().replace(/\s/g,'').includes(q)) : src;
    grid.innerHTML = '';
    emptyEl.style.display = filtered.length ? 'none' : 'block';
    filtered.forEach((v, i) => {
      const btn = document.createElement('button');
      btn.type = 'button';
      const isSale = isSaleVariant(v);
      btn.className = 'lp-size-pill' + (v.id === selectedId ? ' selected' : '') + (isSale ? ' lp-size-pill--sale' : '');
      if (isSale) btn.title = 'Намаление';
      btn.textContent = normalize(v.title);
      btn.dataset.id = v.id; btn.dataset.price = v.price; btn.dataset.title = v.title;
      btn.style.animationDelay = Math.min(i * 18, 280) + 'ms';
      btn.addEventListener('click', () => selectVariant(v.id, v.title, v.price));
      grid.appendChild(btn);
    });
  }

  // QTY STEPPER
  function setQty(n) {
    quantity = Math.max(1, Math.min(999, n));
    if (qtyVal.tagName === 'INPUT') qtyVal.value = quantity; else qtyVal.textContent = quantity;
    qtyInput.value = quantity;
  }
  qtyMinus.addEventListener('click', () => setQty(quantity - 1));
  qtyPlus.addEventListener('click', () => setQty(quantity + 1));

  /* lp-qty-editable — množstvo sa dá napísať, nielen naklikať.
     #lp-qty-val je v sekciách <input>; staršie sekcie mali <span>, preto vieme oboje. */
  (function () {
    if (!qtyVal) return;
    var jeInput = qtyVal.tagName === 'INPUT';
    if (jeInput) {
      qtyVal.setAttribute('maxlength', '4');
    } else {
      qtyVal.setAttribute('contenteditable', 'true');
      qtyVal.setAttribute('inputmode', 'numeric');
      qtyVal.style.outline = 'none';
      qtyVal.style.minWidth = '2.2em';
    }
    function citaj() { return (jeInput ? qtyVal.value : qtyVal.textContent) || ''; }
    function pis(s) { if (jeInput) qtyVal.value = s; else qtyVal.textContent = s; }
    qtyVal.addEventListener('input', function () {
      /* pri písaní neorezávame na 999 — z „1000" by ticho vzniklo „100";
         necháme dopísať a zastropujeme až pri opustení poľa */
      var digits = citaj().replace(/[^0-9]/g, '').slice(0, 4);
      if (digits !== citaj()) pis(digits);
      var n = parseInt(digits, 10);
      if (n >= 1) { quantity = Math.min(999, n); qtyInput.value = quantity; }
    });
    qtyVal.addEventListener('change', function () { setQty(parseInt(citaj(), 10) || 1); });
    qtyVal.addEventListener('blur', function () { setQty(parseInt(citaj(), 10) || 1); });
    qtyVal.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); qtyVal.blur(); }
    });
  })();

  function selectVariant(id, title, price) {
    selectedId = id;
    variantIn.value = id;
    document.querySelectorAll('.lp-size-pill').forEach(p => p.classList.toggle('selected', parseInt(p.dataset.id) === id));
    priceEl.classList.add('updating');
    setTimeout(() => { priceEl.textContent = price; priceEl.classList.remove('updating'); }, 120);
    const norm = normalize(title);
    selLabel.textContent = norm; selLabel.classList.add('visible');
    stickySize.textContent = norm;
    stickyPrice.textContent = price;
    noSelHint.classList.remove('visible');

    const data = VARIANTS.find(v => v.id === id);

    // Interný SKU indikátor — aktualizuj na SKU vybraného variantu
    const skuEl = document.getElementById('lp-sku-internal');
    if (skuEl && data && data.sku) skuEl.textContent = data.sku;

    // ZĽAVA — ak má variant compare_at_price vyššiu než cena, je v akcii
    const onSale = data && data.compareN > data.priceN;
    const wheelSaleEl = document.getElementById('lp-wheel-sale');
    if (onSale) {
      const pct = Math.round((data.compareN - data.priceN) / data.compareN * 100);
      priceOldEl.textContent = data.compare;
      priceOldEl.classList.add('show');
      salePctEl.textContent = '−' + pct + ' %';
      saleBadge.classList.remove('hiding', 'show');
      void saleBadge.offsetWidth;
      saleBadge.classList.add('show');
      if (wheelSaleEl) wheelSaleEl.textContent = '−' + pct + ' %';
      if (stickyPriceOld) { stickyPriceOld.textContent = data.compare; stickyPriceOld.style.display = ''; }
    } else {
      priceOldEl.classList.remove('show');
      if (stickyPriceOld) { stickyPriceOld.textContent = ''; stickyPriceOld.style.display = 'none'; }
      // schovaj badge bumpnutím (nie okamžitým zmiznutím)
      if (saleBadge.classList.contains('show')) {
        saleBadge.classList.remove('show');
        void saleBadge.offsetWidth;
        saleBadge.classList.add('hiding');
      }
    }

    // Wheel: malý "%" indikátor pri zľavnenom rozmere (reálna zľava z compareN)
    if (wheelEl) wheelEl.classList.toggle('is-sale', !!onSale);

    // Bezpečnostná poistka: ak by sa napriek filtru vybral variant mimo skladu,
    // zobraz ružový shape cez obrázok a zablokuj nákup.
    const available = data ? data.available : true;
    if (available) {
      stockOverlay.classList.remove('show');
      addBtn.disabled = false; buyBtn.disabled = false; stickyBtn.disabled = false;
    } else {
      stockOverlay.classList.remove('show');
      void stockOverlay.offsetWidth;            // reštart animácie
      stockOverlay.classList.add('show');
      addBtn.disabled = true; buyBtn.disabled = true; stickyBtn.disabled = true;
    }
  }

  // FLY-TO-CART — kópia produktovej fotky letí z tlačidla do ikony košíka v hlavičke
  function flyToCart(fromEl) {
    try {
      // Ikona košíka v pravom hornom rohu hlavičky (artmie téma).
      // Filtrujeme skryté prvky (mobilné menu má cart link na 0,0).
      let cart = null;
      const sels = ['.cart-drawer__button', '.header-actions__action', '#cart-icon-bubble',
                    '.cart-count-bubble', 'a[href$="/cart"]', 'a[href="/cart"]'];
      for (const s of sels) {
        const els = document.querySelectorAll(s);
        for (const el of els) {
          const r = el.getBoundingClientRect();
          if (r.width > 0 && r.height > 0 && r.top < 200 && r.left > window.innerWidth / 2) { cart = el; break; }
        }
        if (cart) break;
      }
      if (!cart || !fromEl) return;
      const s = fromEl.getBoundingClientRect();
      const e = cart.getBoundingClientRect();
      const fly = document.createElement('img');
      const act = activeStageImg ? activeStageImg() : null;
      fly.src = (act && act.src) ? act.src : mainImgEl.src;
      fly.style.cssText =
        'position:fixed;z-index:99999;pointer-events:none;object-fit:cover;border-radius:12px;' +
        'box-shadow:0 10px 30px rgba(0,0,0,.35);width:90px;height:90px;' +
        'left:' + (s.left + s.width/2 - 45) + 'px;top:' + (s.top + s.height/2 - 45) + 'px;' +
        'transition:left .85s cubic-bezier(.5,-0.25,.7,1),top .85s cubic-bezier(.5,-0.25,.7,1),' +
        'width .85s ease,height .85s ease,opacity .85s ease,transform .85s ease;';
      document.body.appendChild(fly);
      requestAnimationFrame(() => {
        fly.style.left = (e.left + e.width/2 - 14) + 'px';
        fly.style.top  = (e.top + e.height/2 - 14) + 'px';
        fly.style.width = '28px';
        fly.style.height = '28px';
        fly.style.opacity = '.35';
        fly.style.transform = 'rotate(22deg)';
      });
      setTimeout(() => {
        fly.remove();
        if (cart) { cart.style.transition = 'transform .3s cubic-bezier(.34,1.6,.64,1)'; cart.style.transform = 'scale(1.25)'; setTimeout(() => cart.style.transform = '', 320); }
      }, 880);
    } catch (err) {}
  }

  const CART_ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" style="flex-shrink:0;min-width:17px;width:17px;height:17px"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>';
  const CHECK_ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" style="flex-shrink:0;min-width:17px;width:17px;height:17px"><polyline points="20 6 9 17 4 12"/></svg>';

  function showStockError() {
    stockOverlay.classList.remove('show');
    void stockOverlay.offsetWidth;
    stockOverlay.classList.add('show');
  }

  heroForm.addEventListener('submit', function(e) {
    e.preventDefault();
    if (!selectedId) { noSelHint.classList.add('visible'); searchEl.focus(); return; }
    addBtn.classList.add('loading'); addBtn.disabled = true;
    fetch('/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({id: selectedId, quantity: quantity}) })
    .then(r => r.json().then(data => ({ ok: r.ok, data })))
    .then(({ ok, data }) => {
      addBtn.classList.remove('loading');
      if (!ok) {
        // Variant medzičasom vypredaný — ružový shape cez obrázok
        addBtn.disabled = false;
        showStockError();
        return;
      }
      flyToCart(addBtn);
      addBtn.classList.add('success');
      addBtn.querySelector('.lp-btn-cart-text').innerHTML = CHECK_ICON + ' Добавено в количката!';
      setTimeout(() => {
        addBtn.classList.remove('success'); addBtn.disabled = false;
        addBtn.querySelector('.lp-btn-cart-text').innerHTML = CART_ICON + ' Добави в количката';
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      }, 2200);
    })
    .catch(() => { addBtn.classList.remove('loading'); addBtn.disabled = false; });
  });

  buyBtn.addEventListener('click', function() {
    if (!selectedId) { noSelHint.classList.add('visible'); return; }
    buyBtn.disabled = true; buyBtn.textContent = '...';
    fetch('/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({id: selectedId, quantity: quantity}) })
    .then(r => {
      if (!r.ok) {
        buyBtn.disabled = false;
        buyBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" style="flex-shrink:0;min-width:17px;width:17px;height:17px"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg> Купи сега';
        showStockError();
        return;
      }
      window.location.href = '/checkout';
    })
    .catch(() => { buyBtn.disabled = false; buyBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" style="flex-shrink:0;min-width:17px;width:17px;height:17px"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg> Купи сега'; });
  });

  // Sticky bar: zobrazí sa IBA ak je tlačidlo "Купи сега" už NAD viewportom
  // (t.j. zoscrolloval som pod neho). Pri načítaní stránky alebo keď je tlačidlo
  // pod viewportom (vidím ho po scrollnutí dole), sticky ostáva skrytý.
  let stickyTicking = false;
  // Chat widget používa Shadow DOM (mode: open) s :host { all: initial !important;
  // position: fixed !important; bottom: 20px !important; }. `all: initial !important`
  // resetuje aj transform, takže outer CSS to spoľahlivo neprebije. Riešenie:
  // injectovať vlastný <style> PRIAMO do shadow rootu — :host pravidlo neskôr v poradí
  // vyhrá nad widgetovým :host.
  function injectChatShadowStyle(css) {
    const root = document.getElementById('artmie-chatbot-root');
    if (!root || !root.shadowRoot) return false;
    let s = root.shadowRoot.querySelector('style[data-lp-injected]');
    if (!s) {
      s = document.createElement('style');
      s.setAttribute('data-lp-injected', '1');
      root.shadowRoot.appendChild(s);
    }
    s.textContent = css;
    return true;
  }
  function updateChatOffset(show) {
    if (!window.matchMedia('(max-width: 768px)').matches) {
      // desktop: žiaden posun, vyčisti príp. zostatok
      injectChatShadowStyle(':host { transform: none !important; }');
      const r = document.getElementById('artmie-chatbot-root');
      if (r) r.style.removeProperty('transform');
      return;
    }
    const css = show
      ? ':host { transform: translateY(-72px) !important; transition: transform .25s ease !important; }'
      : ':host { transform: none !important; transition: transform .25s ease !important; }';
    injectChatShadowStyle(css);
    // Záložne aj inline style na host (pre prípad iných verzií widgetu)
    const root = document.getElementById('artmie-chatbot-root');
    if (root) {
      root.style.transition = 'transform .25s ease';
      if (show) root.style.setProperty('transform', 'translateY(-72px)', 'important');
      else root.style.removeProperty('transform');
    }
  }
  function updateSticky() {
    const rect = buyBtn.getBoundingClientRect();
    const show = rect.bottom < 0;
    stickyBar.classList.toggle('show', show);
    document.body.classList.toggle('lp-has-sticky', show);
    updateChatOffset(show);
    stickyTicking = false;
  }
  // Widget sa môže načítať až po našom scripte — sleduj jeho objavenie
  (function watchChatRoot(){
    if (document.getElementById('artmie-chatbot-root')) { updateChatOffset(document.body.classList.contains('lp-has-sticky')); return; }
    const mo = new MutationObserver(() => {
      if (document.getElementById('artmie-chatbot-root')) {
        mo.disconnect();
        updateChatOffset(document.body.classList.contains('lp-has-sticky'));
      }
    });
    mo.observe(document.body, { childList: true });
    setTimeout(() => mo.disconnect(), 30000);
  })();
  window.addEventListener('scroll', () => {
    if (!stickyTicking) { requestAnimationFrame(updateSticky); stickyTicking = true; }
  }, { passive: true });
  updateSticky();

  stickyBtn.addEventListener('click', () => {
    if (!selectedId) {
      heroForm.scrollIntoView({ behavior:'smooth', block:'center' });
      setTimeout(() => searchEl.focus(), 600);
      return;
    }
    const original = stickyBtn.innerHTML;
    stickyBtn.disabled = true;
    stickyBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" style="animation:lp-spin .7s linear infinite;width:16px;height:16px"><circle cx="12" cy="12" r="10" opacity=".25"/><path d="M22 12a10 10 0 0 1-10 10"/></svg><span>...</span>';
    fetch('/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({id: selectedId, quantity: quantity}) })
      .then(r => ({ ok: r.ok }))
      .then(({ ok }) => {
        if (!ok) {
          stickyBtn.innerHTML = original;
          stickyBtn.disabled = false;
          showStockError();
          return;
        }
        flyToCart(stickyBtn);
        stickyBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" style="width:16px;height:16px"><polyline points="20 6 9 17 4 12"/></svg><span>W koszyku!</span>';
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        setTimeout(() => {
          stickyBtn.innerHTML = original;
          stickyBtn.disabled = false;
        }, 2000);
      })
      .catch(() => { stickyBtn.innerHTML = original; stickyBtn.disabled = false; });
  });

  const searchClear = document.getElementById('lp-search-clear');
  searchEl.addEventListener('input', () => {
    renderPills(searchEl.value);
    searchClear.classList.toggle('show', searchEl.value.length > 0);
  });
  searchClear.addEventListener('click', () => {
    searchEl.value = '';
    searchClear.classList.remove('show');
    renderPills('');
    searchEl.focus();
  });
  renderPills('');

  // ── WHEEL PICKER rozmerov (mobil — test) ──
  let wheelRebuildFromSrc = function(){};
  (function(){
    var wheelW = document.getElementById('lp-wheel-w');
    var wheelH = document.getElementById('lp-wheel-h');
    var listW  = document.getElementById('lp-wheel-w-list');
    var listH  = document.getElementById('lp-wheel-h-list');
    if (!wheelW || !wheelH || !listW || !listH) return;
    var ITEM = 38;
    // predvýber najlacnejšieho rozmeru robíme len pri PRVOM zostavení kolieska,
    // aby prepnutie filtra zliav nepremazalo to, čo si zákazník už vybral
    var firstBuild = true;

    var byW = {};
    var widths = [];
    var curHeights = [];

    function buildIndex(src){
      byW = {};
      src.forEach(function(v){
        var p = normalize(v.title).split('x');
        if (p.length !== 2) return;
        var a = parseInt(p[0], 10), b = parseInt(p[1], 10);
        if (!a || !b) return;
        (byW[a] = byW[a] || {})[b] = v;
        (byW[b] = byW[b] || {})[a] = v;
      });
      widths = Object.keys(byW).map(Number).sort(function(a,b){ return a-b; });
    }

    function buildList(list, vals){
      list.innerHTML = '';
      vals.forEach(function(val){
        var d = document.createElement('div');
        d.className = 'lp-wheel__item';
        d.textContent = val;
        list.appendChild(d);
      });
    }
    function idxOf(col){ return Math.max(0, Math.round(col.scrollTop / ITEM)); }
    function paint(col, list){
      var idx = idxOf(col), items = list.children;
      for (var i = 0; i < items.length; i++){
        var dist = Math.abs(i - idx);
        items[i].classList.toggle('is-active', i === idx);
        items[i].style.opacity = dist === 0 ? '1' : (dist === 1 ? '.5' : '.22');
        items[i].style.transform = 'scale(' + (dist === 0 ? 1 : (dist === 1 ? .62 : .48)) + ')';
      }
      return idx;
    }
    function heightsFor(w){ return byW[w] ? Object.keys(byW[w]).map(Number).sort(function(a,b){ return a-b; }) : []; }
    function commit(){
      if (!widths.length) return;
      var w = widths[Math.min(widths.length - 1, idxOf(wheelW))];
      var h = curHeights[Math.min(curHeights.length - 1, idxOf(wheelH))];
      var v = w && h && byW[w] && byW[w][h];
      if (v) selectVariant(v.id, v.title, v.price);
    }
    function rebuildHeights(){
      var w = widths[Math.min(widths.length - 1, idxOf(wheelW))];
      var prevH = curHeights[idxOf(wheelH)];
      curHeights = heightsFor(w);
      buildList(listH, curHeights);
      var ni = 0, best = Infinity;
      if (prevH) curHeights.forEach(function(h, i){ var d = Math.abs(h - prevH); if (d < best){ best = d; ni = i; } });
      wheelH.scrollTop = ni * ITEM;
      paint(wheelH, listH);
    }

    wheelRebuildFromSrc = function(src){
      buildIndex(src);
      if (!widths.length) {
        listW.innerHTML = ''; listH.innerHTML = '';
        return;
      }
      buildList(listW, widths);

      // Štartovacia pozícia = najlacnejší variant zo src (mobile picker tak hneď
      // ukáže najlacnejšie skladové plátno)
      var cheapest = null;
      src.forEach(function(v){
        if (typeof v.priceN !== 'number') return;
        if (!cheapest || v.priceN < cheapest.priceN) cheapest = v;
      });
      var startW = widths[0], startH = null;
      if (cheapest) {
        var p = normalize(cheapest.title).split('x');
        var a = parseInt(p[0], 10), b = parseInt(p[1], 10);
        if (widths.indexOf(a) >= 0) { startW = a; startH = b; }
        else if (widths.indexOf(b) >= 0) { startW = b; startH = a; }
      }
      var iW = Math.max(0, widths.indexOf(startW));
      wheelW.scrollTop = iW * ITEM;
      curHeights = heightsFor(startW);
      buildList(listH, curHeights);
      if (startH === null || curHeights.indexOf(startH) < 0) startH = curHeights[0];
      var iH = Math.max(0, curHeights.indexOf(startH));
      wheelH.scrollTop = iH * ITEM;

      paint(wheelW, listW);
      paint(wheelH, listH);
      if (firstBuild || window.matchMedia('(max-width: 768px)').matches) commit();
      firstBuild = false;
    };

    wheelRebuildFromSrc(IN_STOCK);

    function attach(col, list, isW){
      var t;
      col.addEventListener('scroll', function(){
        paint(col, list);
        clearTimeout(t);
        t = setTimeout(function(){
          if (isW) rebuildHeights();
          commit();
        }, 130);
      }, { passive: true });
    }
    attach(wheelW, listW, true);
    attach(wheelH, listH, false);
  })();

  // ── URL ?variant= PRESELECT + SYNC ──
  // Product template: ked Shopify nasmeruje na /products/handle?variant=ID
  // (z kolekcie, z košíka, zo zdielania), preselect ten variant.
  // Naopak, ked user klikne variant v pickeri, replaceState v URL — zdielanie a
  // back-button fungujú natívne.
  (function(){
    function urlVariantId(){
      try { return parseInt(new URLSearchParams(location.search).get('variant'), 10) || null; }
      catch(e){ return null; }
    }
    var initId = urlVariantId();
    if (initId) {
      var v = VARIANTS.find(function(x){ return x.id === initId; });
      if (v && v.available) {
        selectVariant(v.id, v.title, v.price);
        // Posunúť wheel na zvolený rozmer (mobile) — najazd v ďalšom frame, kým je DOM ready
        requestAnimationFrame(function(){
          try {
            var p = (v.title || '').replace(/\s*[xX×]\s*/g, 'x').trim().split('x');
            var a = parseInt(p[0], 10), b = parseInt(p[1], 10);
            var wW = document.getElementById('lp-wheel-w');
            var wH = document.getElementById('lp-wheel-h');
            var listW = document.getElementById('lp-wheel-w-list');
            var listH = document.getElementById('lp-wheel-h-list');
            if (!wW || !wH || !listW || !listH) return;
            var widthsArr = Array.from(listW.children).map(function(el){ return parseInt(el.textContent,10); });
            var iW = widthsArr.indexOf(a);
            if (iW < 0) iW = widthsArr.indexOf(b);
            if (iW >= 0) wW.scrollTop = iW * 38;
          } catch(e){}
        });
      }
    }
    // Sync ked user vyberie variant — necháme to ako wrap selectVariant
    var origSelect = selectVariant;
    selectVariant = function(id, title, price){
      origSelect(id, title, price);
      try {
        var url = new URL(location.href);
        if (String(url.searchParams.get('variant')) !== String(id)) {
          url.searchParams.set('variant', id);
          history.replaceState({}, '', url);
        }
      } catch(e){}
    };
  })();

  // ── SALE TOGGLE — 2 samostatné tlačidlá (Práve zľavnené / Zobraziť všetko) ──
  function applySaleMode(saleOnly){
    SALE_ONLY = saleOnly;
    if (saleToggleSaleBtn) {
      saleToggleSaleBtn.classList.toggle('active', SALE_ONLY);
      saleToggleSaleBtn.setAttribute('aria-pressed', SALE_ONLY ? 'true' : 'false');
    }
    if (saleToggleAllBtn) {
      saleToggleAllBtn.classList.toggle('active', !SALE_ONLY);
      saleToggleAllBtn.setAttribute('aria-pressed', !SALE_ONLY ? 'true' : 'false');
    }
    searchEl.value = '';
    var sc = document.getElementById('lp-search-clear');
    if (sc) sc.classList.remove('show');
    renderPills('');
    wheelRebuildFromSrc(currentVariants());
  }
  if (saleToggleSaleBtn) saleToggleSaleBtn.addEventListener('click', () => { if (!SALE_ONLY) applySaleMode(true); });
  if (saleToggleAllBtn)  saleToggleAllBtn .addEventListener('click', () => { if (SALE_ONLY) applySaleMode(false); });

  // REELS — LAZY LOAD: video sa stiahne a načíta IBA po kliknutí na kartu.
  // Pri load stránky sa nezťahuje nič okrem statického poster obrázka (rovnaký
  // obrázok ako už máme v page). Žiadne dáta zákazníka navyše, žiadne spomalenie.
  const reels = document.querySelectorAll('.lp-reel');
  reels.forEach(reel => {
    const src = reel.dataset.src;
    const soundBtn = reel.querySelector('.lp-reel__sound');
    const soundOn  = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"/><path d="M15.54 8.46a5 5 0 0 1 0 7.07"/><path d="M19.07 4.93a10 10 0 0 1 0 14.14"/></svg>';
    const soundOff = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"/><line x1="23" y1="9" x2="17" y2="15"/><line x1="17" y1="9" x2="23" y2="15"/></svg>';
    let video = null;

    // Ak nie je URL videa, karta zostane ako static poster bez funkcionality
    if (!src || src.length === 0) {
      reel.style.cursor = 'default';
      return;
    }

    function ensureVideo() {
      if (video) return video;
      const poster = reel.querySelector('img');
      video = document.createElement('video');
      video.src = src;
      video.muted = true;          // bez zvuku, používateľ ho aktívne zapne
      video.loop = true;
      video.playsInline = true;
      video.setAttribute('webkit-playsinline', '');
      video.preload = 'none';      // nič sa nezťahuje kým user neklikne
      if (poster) video.poster = poster.src;
      reel.replaceChild(video, poster);
      // Auto-pause keď scrolnem preč (šetrí výkon)
      new IntersectionObserver(entries => {
        entries.forEach(e => { if (!e.isIntersecting && !video.paused) video.pause(); });
      }, { threshold: 0.2 }).observe(reel);
      // Sync UI keď video zastavíš tlačidlom
      video.addEventListener('play', () => reel.classList.add('playing'));
      video.addEventListener('pause', () => reel.classList.remove('playing'));
      return video;
    }

    reel.addEventListener('click', (ev) => {
      if (ev.target.closest('.lp-reel__sound')) return;
      const v = ensureVideo();
      if (v.paused) v.play().catch(() => {}); else v.pause();
    });

    soundBtn.addEventListener('click', (ev) => {
      ev.stopPropagation();
      const v = ensureVideo();
      if (v.paused) v.play().catch(() => {});
      v.muted = !v.muted;
      soundBtn.innerHTML = v.muted ? soundOff : soundOn;
    });
  });

  // GALÉRIA — šípky na posúvanie miniatúr (desktop: 4 viditeľné + scroll)
  const thumbsBox = document.getElementById('lp-thumbs');
  const thumbUp   = document.getElementById('lp-thumb-up');
  const thumbDown = document.getElementById('lp-thumb-down');
  if (thumbsBox && thumbUp && thumbDown) {
    const STEP = 204; // ~2 miniatúry (2×92 + 2×10)
    function updateThumbNav() {
      const scrollable = thumbsBox.scrollHeight > thumbsBox.clientHeight + 2;
      const atTop = thumbsBox.scrollTop <= 2;
      const atBottom = thumbsBox.scrollTop + thumbsBox.clientHeight >= thumbsBox.scrollHeight - 2;
      thumbUp.hidden = !scrollable || atTop;
      thumbDown.hidden = !scrollable || atBottom;
    }
    thumbUp.addEventListener('click', () => thumbsBox.scrollBy({ top: -STEP, behavior: 'smooth' }));
    thumbDown.addEventListener('click', () => thumbsBox.scrollBy({ top: STEP, behavior: 'smooth' }));
    thumbsBox.addEventListener('scroll', updateThumbNav, { passive: true });
    window.addEventListener('resize', updateThumbNav);
    updateThumbNav();
  }

  // GALÉRIA — stage so 6 fotkami, cross-slide z fotky na fotku
  const stage   = document.getElementById('lp-stage');
  const stageImgs = stage ? Array.from(stage.querySelectorAll('.lp-stage__img')) : [];
  const mainImg = document.getElementById('lp-main-img'); // = stageImgs[0], kompatibilita
  const thumbs  = document.querySelectorAll('.lp-thumb');
  const arrowPrev = document.getElementById('lp-arrow-prev');
  const arrowNext = document.getElementById('lp-arrow-next');
  const progressBar = document.getElementById('lp-mobile-progress-bar');
  let currentIdx = 0;
  function activeStageImg() {
    return stageImgs.find(im => im.classList.contains('active')) || mainImg;
  }
  function updateGalleryControls(idx) {
    // šípky cyklia donekonečna, nikdy nie sú disabled
    if (arrowPrev) arrowPrev.toggleAttribute('disabled', false);
    if (arrowNext) arrowNext.toggleAttribute('disabled', false);
    if (progressBar && thumbs.length) {
      const n = (stageImgs && stageImgs.length) ? stageImgs.length : thumbs.length;
      if (n > 0) {
        progressBar.style.width = (100 / n) + '%';
        progressBar.style.transform = 'translateX(' + (idx * 100) + '%)';
      }
    }
  }
  let slideBusy = false;
  function goToThumb(idx, dir) {
    if (idx < 0 || idx >= stageImgs.length) return;
    if (idx === currentIdx) {
      thumbs.forEach(x => x.classList.remove('active'));
      if (thumbs[idx]) thumbs[idx].classList.add('active');
      updateGalleryControls(idx);
      return;
    }
    if (slideBusy) return;
    if (!dir) dir = idx > currentIdx ? 'next' : 'prev';

    const oldImg = stageImgs[currentIdx];
    const newImg = stageImgs[idx];

    // Postav novú fotku okamžite (bez animácie) na stranu odkial má prísť
    const prepClass = dir === 'next' ? 'prep-right' : 'prep-left';
    newImg.classList.remove('active','out-left','out-right','prep-left','prep-right');
    newImg.classList.add(prepClass);
    void newImg.offsetWidth;

    // Cross-slide — obe sa pohnú súčasne, plynulo
    slideBusy = true;
    requestAnimationFrame(() => {
      newImg.classList.remove(prepClass);
      newImg.classList.add('active');
      oldImg.classList.remove('active');
      oldImg.classList.add(dir === 'next' ? 'out-left' : 'out-right');
    });

    // Po dokončení animácie odsuň všetky neaktívne mimo (right side), pripravené na ďalší slide
    setTimeout(() => {
      stageImgs.forEach((im, i) => {
        if (i !== idx) {
          im.classList.remove('active','out-left','out-right','prep-left');
          im.classList.add('prep-right');
        }
      });
      slideBusy = false;
    }, 460);

    currentIdx = idx;
    thumbs.forEach(x => x.classList.remove('active'));
    if (thumbs[idx]) thumbs[idx].classList.add('active');
    updateGalleryControls(idx);
    try { if (thumbs[idx]) thumbs[idx].scrollIntoView({ behavior:'smooth', block:'nearest', inline:'nearest' }); } catch(e){}
  }
  thumbs.forEach((t, idx) => {
    t.addEventListener('click', () => goToThumb(idx));
  });

  // Šípky na hlavnej fotke (desktop)
  function currentThumbIdx(){
    let i = 0;
    thumbs.forEach((t, k) => { if (t.classList.contains('active')) i = k; });
    return i;
  }
  if (arrowPrev) arrowPrev.addEventListener('click', () => {
    const i = currentThumbIdx();
    const next = (i - 1 + thumbs.length) % thumbs.length;
    goToThumb(next, 'prev');
  });
  if (arrowNext) arrowNext.addEventListener('click', () => {
    const i = currentThumbIdx();
    const next = (i + 1) % thumbs.length;
    goToThumb(next, 'next');
  });
  updateGalleryControls(0);

  // SWIPE na hlavnej fotke — prepne na ďalší/predošlý thumb
  (function(){
    if (!stage) return;
    let sx = 0, sy = 0, sw = false;
    function start(e){
      const t = e.touches ? e.touches[0] : e;
      sx = t.clientX; sy = t.clientY; sw = true;
    }
    function end(e){
      if (!sw) return; sw = false;
      const t = e.changedTouches ? e.changedTouches[0] : e;
      const dx = t.clientX - sx, dy = t.clientY - sy;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
      const i = currentIdx, n = thumbs.length;
      if (n < 2) return;
      if (dx < 0)      goToThumb((i + 1) % n, 'next');
      else if (dx > 0) goToThumb((i - 1 + n) % n, 'prev');
    }
    stage.addEventListener('touchstart', start, { passive: true });
    stage.addEventListener('touchend',   end,   { passive: true });
  })();

  // FAQ accordion — rozbalenie odpovede po kliku
  document.querySelectorAll('.lp-faq__item .lp-faq__q').forEach(function(btn){
    btn.addEventListener('click', function(){
      var item = btn.closest('.lp-faq__item');
      item.classList.toggle('open');
    });
  });

  // SECTION TABS — smooth scroll + active podľa pozície scrollu
  (function(){
    const tabs = document.querySelectorAll('.lp-tab');
    if (!tabs.length) return;
    const targets = Array.from(tabs).map(t => ({ tab: t, id: t.dataset.target, el: document.getElementById(t.dataset.target) })).filter(x => x.el);
    tabs.forEach(t => {
      t.addEventListener('click', (e) => {
        e.preventDefault();
        const id = t.dataset.target;
        const el = document.getElementById(id);
        if (!el) return;
        const rect = el.getBoundingClientRect();
        const top = rect.top + window.pageYOffset - 20;
        window.scrollTo({ top, behavior: 'smooth' });
      });
    });
    // Aktívny tab podľa pozície scrollu (najbližšia sekcia nad strednou líniou viewportu)
    function updateActive() {
      const mid = window.scrollY + window.innerHeight * 0.30;
      let active = targets[0];
      for (const t of targets) {
        if (t.el.offsetTop <= mid) active = t;
      }
      tabs.forEach(x => x.classList.toggle('active', x === active.tab));
    }
    let tick = false;
    window.addEventListener('scroll', () => {
      if (!tick) { requestAnimationFrame(() => { updateActive(); tick = false; }); tick = true; }
    }, { passive: true });
    updateActive();
  })();

  // LIGHTBOX — klik na hlavný obrázok = zväčšenie (vždy aktívna fotka v stage)
  const lightbox      = document.getElementById('lp-lightbox');
  const lightboxImg   = document.getElementById('lp-lightbox-img');
  const lightboxClose = document.getElementById('lp-lightbox-close');
  if (lightbox && lightboxImg && stage) {
    let sxL = 0, syL = 0;
    stage.addEventListener('touchstart', e => {
      const t = e.touches[0]; sxL = t.clientX; syL = t.clientY;
    }, { passive: true });
    function openLightbox(e) {
      // Ignoruj klik ak išlo o swipe (väčší pohyb)
      if (e && e.changedTouches) {
        const t = e.changedTouches[0];
        if (Math.abs(t.clientX - sxL) > 10 || Math.abs(t.clientY - syL) > 10) return;
      }
      const act = activeStageImg();
      lightboxImg.src = act ? act.src : '';
      lightbox.classList.add('open');
      document.body.style.overflow = 'hidden';
    }
    function closeLightbox() {
      lightbox.classList.remove('open');
      document.body.style.overflow = '';
    }
    stage.addEventListener('click', openLightbox);
    lightbox.addEventListener('click', closeLightbox);
    lightboxClose.addEventListener('click', closeLightbox);
    document.addEventListener('keydown', e => { if (e.key === 'Escape') closeLightbox(); });
  }
})();
